// extracted by mini-css-extract-plugin
export var reviews = "onetrustcookiebutton-module--reviews--91492";